(function () {
  var params = new URLSearchParams(window.location.search);

  // --- capture coupon ---
  var coupon = params.get('coupon') || params.get('discount');
  if (coupon) {
    setCookie('qr_coupon', coupon.toUpperCase(), 7);
  }

  // --- capture UTMs ---
  ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(function(k){
    var v = params.get(k);
    if (v) setCookie(k, v, 7);
  });

  // --- inject into GoKwik when checkout opens ---
  var savedCoupon = getCookie('qr_coupon');
  if (savedCoupon && window.gokwik) {
    try {
      window.gokwik.setCoupon && window.gokwik.setCoupon(savedCoupon);
    } catch(e) {}
  }

  // --- also inject via GoKwik config if present ---
  if (savedCoupon) {
    document.addEventListener('gokwik:ready', function () {
      try {
        window.gokwik.setCoupon && window.gokwik.setCoupon(savedCoupon);
      } catch(e) {}
    });
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) +
      '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }
})();